export default function Home() {
	return (
		<div className="home_container">
			<div className="home_content_container">
				<div className="home_content">
					<h1>Thinking about travelling soon?</h1>
					<h2>Let us help you with that.</h2>
					<p>
						There are amazing countries to visit, so if you're thinking of
						travelling check out all the important information and fun facts
						about each country.
					</p>
				</div>
			</div>
		</div>
	);
}
